import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import AdminSidebar from 'admin/sidebar/AdminSidebar';
import { Link } from 'react-router-dom';
import './SuperAdminPackages.css';
import PackageSetsPage from 'admin/components/pakageSetComp/PakageSetComp';
const PackageSets = () => {
  
  useEffect(() => { window.scrollTo(0, 0); }, []);

  

  return (
    <div className="mainDiv-all-sideBar">
      <div className="div-sidebar"><AdminSidebar /></div>
      <div className="div-Dashbaord" style={{background:'white',padding:0}}>
        <PackageSetsPage/>
      </div>

      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default PackageSets;